// extracted by mini-css-extract-plugin
module.exports = {"posts":"Posts_posts__I6c1p","posts__title":"Posts_posts__title__LhIh4","posts__container":"Posts_posts__container__Vg5rC","posts__item":"Posts_posts__item__MYEeB"};